const BASE_URL = process.env.NODE_ENV === "development" ? 'http://localhost:5100/' : 'https://apps.appitrace.com/';
export const IMAGE_URL = process.env.NODE_ENV === "development" ? 'http://localhost:5100/images/' : 'https://apps.appitrace.com/app/images/';

// CMS
export const ANALYSTIC_URL = BASE_URL + 'analytic'
export const SAVE_CONTACT_US_URL = BASE_URL + 'cms/contact-us'
export const FAQ_URL = BASE_URL + 'faq'